module.exports = __webpack_public_path__ + "img/header-weddingRingsNaturalBeige.ad2fc93.webp";